function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import "./WidgetSpinner.scss";

class WidgetSpinner extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getStyle", () => {
      let _this$props = this.props,
          theme = _this$props.theme,
          style = _this$props.style;

      if (style && style.color) {
        return {
          backgroundColor: style.color
        };
      }

      if (theme && theme.primaryColor) {
        return {
          backgroundColor: theme.primaryColor
        };
      }

      return {};
    });
  }

  render() {
    const style = this.getStyle();
    return React.createElement("div", {
      className: "admin-widget__spinner"
    }, React.createElement("div", {
      className: "anim-1",
      style: style
    }), React.createElement("div", {
      className: "anim-2",
      style: style
    }), React.createElement("div", {
      className: "anim-3",
      style: style
    }));
  }

}

export default WidgetSpinner;